import type { ScannerAction, ScannerState } from "./types";

export const initialScannerState: ScannerState = {
  kind: "requesting-permission",
};

export function scannerReducer(
  state: ScannerState,
  action: ScannerAction,
): ScannerState {
  switch (action.type) {
    case "PERMISSION_GRANTED":
      if (state.kind !== "requesting-permission") return state;
      return { kind: "searching", stuckHintShown: false };

    case "PERMISSION_DENIED":
      return { kind: "unavailable", reason: action.reason };

    case "DECODE_SUCCESS":
      if (state.kind !== "searching") return state;
      return { kind: "locked-on", raw: action.raw, points: action.points };

    case "STUCK_HINT_ELAPSED":
      if (state.kind !== "searching") return state;
      if (state.stuckHintShown) return state;
      return { ...state, stuckHintShown: true };

    case "LOCK_TIMER_ELAPSED":
      if (state.kind !== "locked-on") return state;
      return { kind: "parsing", raw: state.raw };

    case "PARSE_OK":
      if (state.kind !== "parsing") return state;
      return { kind: "success", parsed: action.parsed };

    case "PARSE_FAIL":
      if (state.kind !== "parsing") return state;
      return { kind: "unrecognized" };

    case "TRY_AGAIN":
      if (state.kind !== "unrecognized") return state;
      return { kind: "searching", stuckHintShown: false };

    case "CANCEL":
      // Parent component handles modal closure; reducer leaves state alone.
      return state;

    default:
      // Unreachable under TypeScript's exhaustiveness check, but if an
      // unknown action slips through at runtime, return the current state
      // instead of falling through and implicitly returning undefined.
      return state;
  }
}
